var menu =  (function() {
	
	$(".carousel-indicator-active").addClass("active");
	
	$(".menu-kennis > a").click(function(e) {
		e.preventDefault();
		
		$(".menu-kennis ul.sub-menu").slideToggle('medium', function(){
			if ($(this).is(':visible'))
			$(this).css('display','flex');
		});
	});
	
	
	// Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('header').outerHeight();
	
	$(window).scroll(function(event){
	    didScroll = true;
	});
	
	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);
	
	function hasScrolled() {
	    var st = $(this).scrollTop();
	    
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;
	    
	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        $('header').removeClass('nav-down').addClass('nav-up');
	    } else {
	        // Scroll Up
	        if(st + $(window).height() < $(document).height()) {
	            $('header').removeClass('nav-up').addClass('nav-down');
	        }
	    }
	    
	    lastScrollTop = st;
	}
	
	$("#search-btn").click(function(e) {
		e.preventDefault();
		
		$("#search-box").toggleClass("in");
	});
})();

var onderwerp =  (function() {
	$('.post-reactie').click(function(e) {
		e.preventDefault();
		var errors = false;
		
		if ($(this).parent().find("input[name='naam']").val() == "") {
			$(this).parent().find("input[name='naam']").addClass('error');
			errors = true;
		} else {
			$(this).parent().find("input[name='naam']").removeClass('error');
		}
		
		if ($(this).parent().find("input[name='email']").val() == "") {
			$(this).parent().find("input[name='email']").addClass('error');
			errors = true;
		} else {
			$(this).parent().find("input[name='email']").removeClass('error');
		}
		
		if ($(this).parent().find("textarea[name='reactie']").val() == "") {
			$(this).parent().find("textarea[name='reactie']").addClass('error');
			errors = true;
		} else {
			$(this).parent().find("textarea[name='reactie']").removeClass('error');
		}
		
		if (!errors) {
			var comment = $(this).parent().serialize();
			$(this).parent().html("Uw reactie is verzonden!");
			
			var data = {
	            action: 'sendComment',
	            nonce: WPAjax.nonce,
	            form: comment
	        };
			
			$.getJSON( WPAjax.ajaxurl, data, function(response) { 
				console.log(response);
			});
		}
	});
})();

//laposta form placeholder
$(document).ready(function() {
	$("#id-plfONBIOIN").attr("placeholder", "Uw emailadres...");  
  });
  


